import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng-lts/button';
import { TableModule } from 'primeng-lts/table';
import { AssignManagerComponent } from './component/assignManager.component';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { UserModule } from '../../user/user/user.module';

@NgModule({
  declarations: [AssignManagerComponent],
  imports: [TranslateModule,
    CommonModule,
    TableModule,
    ButtonModule,
    UserModule,
    FormPlycaModule]
})
export class AssignManagerModule { }
